import FilterResults from './FilterResults';

export default FilterResults;
